module.exports = __webpack_public_path__ + "media/styles/images/png/circle-check-gray-dark-on-white-97bc6cd7e7575ec27fac43d6edea2979.png";